import {IFactory} from '../../calculator-globals/database/factory.interface';
import {IXultophyScenario, Scenario} from '../models/scenario.class';

export class XultophyFactory extends IFactory {
  create(type: any, params?: IXultophyScenario): any {
    switch (type) {
      case MODEL.Scenario:
        return new Scenario(params);
      default:
        throw new Error('Model not found');
    }
  }
}

export enum MODEL {
  Scenario
}
